module.exports = __webpack_public_path__ + "img/star-rating-calculator.178a5183.png";